import {
  FETCH_SERVICIOS_REQUEST,
  FETCH_SERVICIOS_SUCCESS,
  FETCH_SERVICIOS_FAILURE,
} from "../actions/servicios/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SERVICIOS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SERVICIOS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_SERVICIOS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
